/*
 * Copyright (c) 2025 Amazon.com, Inc. or its affiliates. All rights reserved.
 *
 * PROPRIETARY/CONFIDENTIAL. USE IS SUBJECT TO LICENSE TERMS.
 */

import {PhotoPicker} from './PhotoPicker';
import * as styles from './styles/PhotoSelectionScreen.module.scss';
import {useBundle} from '@amzn/react-arb-tools';
import {HOMEPAGE_MESSAGE_BUNDLE_NAME} from 'src/constants';
import {t} from 'src/helpers';
import {usePhotoFormController} from '../photoForm/PhotoFormController';
import {Screen} from 'src/theming/components/Screen';
import {Header} from 'src/theming/components/Header';
import {Button} from 'src/theming/components/Button';
import {MAXIMUM_PHOTO_COUNT} from 'src/photoForm/validation';
import {TEST_IDS} from 'src/testing/TestIds';

export const PhotoSelectionScreen = () => {
  const [bundle] = useBundle(HOMEPAGE_MESSAGE_BUNDLE_NAME);
  const {fields, onSubmit} = usePhotoFormController();

  return (
    <Screen as="form" onSubmit={onSubmit} className={styles.container}>
      <Header
        title={t(bundle, 'photo_selection_title') ?? ''}
        description={t(bundle, 'photo_selection_description')}
      />
      <PhotoPicker className={styles.photoGrid} />
      <Button
        type="submit"
        className={styles.button}
        disabled={fields.length === 0}
        label={
          fields.length === 0
            ? t(bundle, 'submit_button_empty_form_label', {
                photoLimit: MAXIMUM_PHOTO_COUNT,
              })
            : t(bundle, 'submit_button_nonempty_form_label')
        }
        fullWidth
        data-testid={TEST_IDS.PhotoSelectionScreen.SubmitButton}
      />
    </Screen>
  );
};
